import React, { Component } from 'react';
import './css/DeckSelector.css';
import { withTranslation } from 'react-multi-lang';
import {MainContext} from "../Context";
import ConfirmPrompt from "./ConfirmPrompt";

class DeckSelector extends Component {

    static contextType = MainContext;

    constructor(props) {
        super(props);
        this.render = this.render.bind(this);
        this.addDeck = this.addDeck.bind(this);
        this.deleteDeck = this.deleteDeck.bind(this);
        this.getActiveDeck = this.getActiveDeck.bind(this);
        this.state = {
            confirmOpen: false,
            confirmTitle: "",
            onConfirm: () => {}
        };
    }


    async addDeck() {
        this.props.addDeck(this.props.deck);
    }

    async deleteDeck() {
        const { t } = this.props;
        this.setState({confirmOpen: true, confirmTitle: t('gameplay.remove_confirm'), onConfirm: () => this.props.removeDeck(this.getActiveDeck())});
    }

    getActiveDeck() {
        return (this.props.activeDecks.find(x => x.id === this.props.deck._id));
    }

    render() {
        const activeDeck = this.getActiveDeck();
        const isCustomDeck = !!(
            this.props.deck &&
            (
                this.props.deck.isCustom ||
                this.props.deck.custom ||
                this.props.deck.customDeck ||
                String(this.props.deck.id || this.props.deck._id || "").startsWith("custom_") ||
                String(this.props.deck.image || "").includes("/uploads/custom_decks")
            )
        );

        const deckSelectorClassName = [
            "deck-selector",
            activeDeck ? "active deck-selector--selected" : "",
            isCustomDeck ? "deck-selector--custom" : "",
        ]
            .filter(Boolean)
            .join(" ");

        return (
            <>
                <ConfirmPrompt open={this.state.confirmOpen} title={this.state.confirmTitle} onClose={() => this.setState({confirmOpen: false})} onConfirm={this.state.onConfirm} />
<div 
  className={deckSelectorClassName} 
  onClick={() => {
    if (this.props.deck.isLocked) return; // Prevent clicking if locked
    activeDeck ? this.deleteDeck() : this.addDeck();
  }}
>
  <div style={{ position: "relative", display: "inline-block" }}>
    <img 
      src={this.props.deck.id && this.props.deck.id.startsWith('custom_') ? this.props.deck.image : this.props.deck.image} 
      className={this.props.deck.isLocked ? "grayscale filter blur-sm" : ""}
      style={this.props.deck.isLocked ? { filter: "grayscale(100%) blur(2px)" } : {}}
      alt="Deck"
    />
    {this.props.deck.isLocked && (
      <div style={{ position: "absolute", top: "5px", right: "5px", fontSize: "1.5rem" }}>??</div>
    )}
  </div>
  {this.props.deck.name}
</div> 
            </>
        );
    }

}

export default withTranslation(DeckSelector);
